import {
  FETCH_SERVICES_DATA_REQUEST,
  FETCH_SERVICES_DATA_SUCCESS,
  FETCH_SERVICES_DATA_ERROR,
  CREATE_SERVICE_REQUEST,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_ERROR
} from './actions';

export default function servicesDataReducer(
  state = {
    services: [],
    isFetching: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case FETCH_SERVICES_DATA_REQUEST:
      return { ...state, error: null, isFetching: true };
    case FETCH_SERVICES_DATA_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false
      };
    case FETCH_SERVICES_DATA_ERROR:
      return { ...state, error: action.payload, isFetching: false };
    case CREATE_SERVICE_REQUEST:
      return { ...state, error: null, isFetching: true };
    case CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        services: [
          ...state.services,
          action.payload
        ],
        isFetching: false
      };
    case CREATE_SERVICE_ERROR:
      return { ...state, error: action.payload, isFetching: false };
    default:
      return state;
  }
}
